export const emailIsApplePrivateRelay = (email: string): boolean =>
  email.endsWith('@privaterelay.appleid.com');
